module.exports = __webpack_public_path__ + "static/media/default1.ab6d844d.png";